(function ($){

    initDynamicTitle();

    function addStandardParameters(formData) {
        formData['return-type'] = 'json';
        formData[window.formToken] = 1;
    }

    function disableRegisterButton(){
        $('.loginbtn').prop('disabled', true);
    }

    function enableRegisterButton(){
        $('.loginbtn').prop('disabled', false);
    }

    function initDynamicTitle() {
        var prefix = "Ya da bunlarla ";
        $(".vvns-login").click(function () {
            $(document).attr("title", "Giriş Yap - Vivense");
            $('#other-caption').text(prefix + "giriş yapabilirsin");
        });

        $(".vvns-signUp").click(function () {
            $(document).attr("title", "Üye Ol - Vivense");
            $('#other-caption').text(prefix + "üye olabilirsin");
        });
    }

    function handleRegisterResult(response){
        if (response.status) {
            window.location = response.redirectURL;
        } else {
            enableRegisterButton();
            showErrorMessage(response.error);
        }
    }

    function showErrorMessage(message){
        $(".vivense-registration-page").append("<span class='generalErrorMessage'>" + message + "</span>");
    }

    function initInputFocus() {
        $('.vvns-input input').focus(function (){
            $(this).closest( ".vvns-input" ).addClass('active');
        });

        //Hide dial code when empty input

        $(".iti__selected-dial-code").css("display","none");

        $('#tel').focus(function () {
            $(".iti__selected-dial-code").css("display", "block");
        }).focusout(function () {
            if ($(this).val() === "") {
                $(".iti__selected-dial-code").css("display", "none");
            }
        });

        $('.vvns-input input').blur(function (){
            var inputValue = $(this).val();
            if ( inputValue == "" ) {
                $(this).parent().removeClass('active');
                $(this).parents('.vvns-input').removeClass('active');
            } else {
                $(this).parent().addClass('active');
            }
        });
    }

    $(function (){

        //Hide and Show Password
        $(".toggle-password").click(function() {
            $(this).toggleClass("fa-eye fa-eye-slash");
            var pass = $(".vivense-registration-page__password");
            if (pass.attr("type") == "password") {
                pass.attr("type", "text");
            } else {
                pass.attr("type", "password");
            }
        });

        var subForm = $(".vivense-communication-channel-wrapper");
        subForm.hide();

        var validateCheckboxGroup = false;

        var checkOneOfTheRequiredOptionIsSelected = (function(){

            if(!validateCheckboxGroup) {
                return
            }

            if($('.required-checkbox:checked').length >= 1 && form.valid()) {
                enableRegisterButton();
            }else {
                disableRegisterButton();
            }

            if($('.required-checkbox:checked').length >= 1) {
                $(".vvns-communication-text-information").css("visibility", "hidden");
            }else {
                $(".vvns-communication-text-information").css("visibility", "visible");
            }
        });


        $('.required-checkbox').on("input", function() {
            checkOneOfTheRequiredOptionIsSelected()
        });


        $("#vvns-approve-campaign, #vvns-not-approve-campaign").on('change', function(e){
            if(Number(e.target.value, 10) === 0) {
                subForm.hide();
                validateCheckboxGroup = false;
                $('.required-checkbox').prop('checked', false); // Unchecks it
            }else {
                subForm.show();
                validateCheckboxGroup = true;
            }

            checkOneOfTheRequiredOptionIsSelected()
        });

        var customerName = $("#firstname");
        var phone = $("#tel");

        Vivense.stringUtil.capitalizeString(customerName);
        Vivense.stringUtil.removeNumbersFromElement(customerName);
        Vivense.maskUtil.initPhoneMask(phone);
        initInputFocus();

        var form = $("#registration");

        var checkIsValid = function() {
            if (form.validate().checkForm()) {
                enableRegisterButton();
            } else {
                disableRegisterButton();
            }
        }


        $(".vivense-registration-page__email").on('input', function (e) {
            return $(e.target).val(function (i, v) {
                return v.toLowerCase();
            });
        });

        $.validator.addMethod('isValidPhone', function () {
            return Vivense.maskUtil.validatePhone(phone)
        }, 'Geçerli bir telefon numarası giriniz!');


        // Wait for the DOM to be ready
        $(function() {
            $("form[name='registration']").validate({
                errorClass: "error fail-alert",
                validClass: "valid success-alert",

                rules: {
                    "firstname": {
                        required: true
                    },
                    "tel": {
                        required: true,
                        minlength: 10,
                        isValidPhone : true
                    },
                    "email": {
                        required: true,
                        email: true
                    },
                    "password": {
                        required: true,
                        minlength: 4
                    },
                    "tos":{
                        required: true
                    },
                },

                onclick: checkIsValid,
                onkeyup: checkIsValid,
                //showErrors() {},

                messages: {
                    firstname: "Lütfen isim ve soyisminizi giriniz",
                    phone: "Lütfen numaranızı giriniz",
                    password: {
                        required: "Lütfen şifrenizi giriniz",
                        minlength: "Şifreniz en az 5 karakter uzunluğunda olmalıdır"
                    },
                    email: "Lütfen geçerli bir e-posta adresi giriniz",
                },

                submitHandler: function(form) {
                    form.submit();
                },
            });
        });

        $("#registerBtn").click(function (event){

            event.preventDefault();
            disableRegisterButton();

            var registerForm = {
                name: $("#firstname").val(),
                phone: $("#tel").intlTelInput('getNumber') ,
                email1: $("#email").val(),
                password1: $("#password").val()
            };

            var permissions = {
                sms_permission: $('input[name="sms_permission"]:checked').val(),
                mail_permission: $('input[name="mail_permission"]:checked').val(),
                call_permission: $('input[name="call_permission"]:checked').val(),
            };

            var formData = {
                jform : registerForm,
                communicationPermissions: permissions
            };


            addStandardParameters(formData);

            var signupForm = $("#sign-up");

            $.ajax({
                type: "POST",
                url: "index.php?option=com_users&task=registration.register",
                data: formData,
                dataType: "json",
                encode: true,
                beforeSend :function (){
                    Vivense.blockUtil.blockUI(signupForm);
                },
                success: function (response) {
                    handleRegisterResult(response);
                },
                error: function () {
                    showErrorMessage("Bağlantı hatası tekrar deneyiniz!");
                    enableRegisterButton();
                },
                complete: function () {
                    Vivense.blockUtil.unblockUI(signupForm);
                }
            })

        })

        $(function () {
            $("#loginEmail").keyup(function () {
                var VAL = this.value;

                var email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

                if (email.test(VAL)) {
                    $('.user-register-button').prop("disabled", false);
                    $(this).addClass("valid success-alert");
                    $(this).removeClass("error fail-alert");
                }else{
                    $('.user-register-button').prop("disabled", true);
                    $(this).addClass("error fail-alert");
                    $(this).removeClass("valid success-alert");
                }
            });
        });
    });
}(jQuery));
